import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "../../utils/cn";

type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "size"> & {
  hasError?: boolean;
  /** Density variant: "default" for forms, "compact" for dense UIs */
  size?: "default" | "compact";
};

const sizeClasses = {
  default: "h-11 text-sm px-3 rounded-md",
  compact: "h-8 text-xs px-2.5 rounded",
} as const;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, hasError, size = "default", ...props }, ref) => {
    const sizeClass = sizeClasses[size] ?? sizeClasses.default;
    return (
    <input
      ref={ref}
      className={cn(
        "w-full border border-border bg-input text-foreground",
        sizeClass,
        "transition-all duration-200 placeholder:text-muted-foreground",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        "focus-visible:bg-[rgb(var(--focus))]",
        hasError && "border-destructive focus-visible:ring-destructive",
        className
      )}
      {...props}
    />
    );
  },
);

Input.displayName = "Input";
